<template>
  <form-container size="small">
    <h3>{{ $t('resetPassword.title') }}</h3>

    <b-form-group :label="$t('resetPassword.email')" label-for="email" :description="$t('resetPassword.description')">
      <b-form-input
        id="email"
        name="email"
        type="email"
        v-model="email"
        v-bind:disabled="isLoading || isSucceeded"
        v-validate="'required|email'"
        :data-vv-as="$t('resetPassword.email')"/>
      <span v-show="errors.has('email')" class="form__error">{{ errors.first('email') }}</span>
    </b-form-group>

    <b-button
      v-if="!isLoading && !isSucceeded"
      v-bind:disabled="!isValid"
      @click="reset"
      variant="primary">
        {{ $t('resetPassword.performReset') }}
    </b-button>

    <b-button
      to="/login"
      variant="primary">
        <icon name="arrow-right"></icon>
        {{ $t('resetPassword.performLogin') }}
    </b-button>

    <loading-indicator v-if="isLoading"/>

    <b-alert v-if="errorMsg" variant="danger" show>{{ errorMsg }}</b-alert>
    <b-alert v-if="isSucceeded" variant="info" show>{{ $t('resetPassword.successMsg') }}</b-alert>
  </form-container>
</template>

<script>
/**
* Shows a form for resetting a user's password. User has to enter the email
* address and will get sent a mail with the reset link.
* Emits the event 'logged-in' when done.
*/
export default {
  name: 'LoginForm',
  data () {
    return {
      email: '',
      isLoading: false,
      errorMsg: null,
      isSucceeded: false
    }
  },
  computed: {
    isValid () {
      return !this.errors.any()
    }
  },
  methods: {
    async reset () {
      if (!this.isValid) {
        return
      }

      this.errorMsg = null
      this.isLoading = true

      const params = { email: this.email.toLowerCase() }
      try {
        await this.$store.dispatch('resetPassword', params)
        this.isSucceeded = true
      } catch (error) {
        this.errorMsg = error.message
      }

      this.isLoading = false
    }
  }
}
</script>

<style scoped>
.login-link {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/ResetPasswordScreen.vue